import React, { useState } from 'react';
import {
  Link
} from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Navbar,
  Row
} from 'react-bootstrap';
import { 
  FaCarCrash
} from "react-icons/fa";

import logo from '../images/repcaster_logo_txt.png';
import '../App.css';

export default function Error() {

  return (

    <Container fluid className="d-flex flex-column g-0">
      <Navbar bg="light" expand="false" className="container-fluid">
        <Container fluid>
          <Col xs={6}>
            <img src={logo} className="landing-logo float-start" alt="logo" />
          </Col>
          <Col xs={6} className="text-end px-2">
            <span></span>
          </Col>
        </Container>
      </Navbar>
      <Container className="pt-3 mb-5 content-container">
        <Row>
          <Col><h1>Uh-oh. Something busted...</h1></Col>
        </Row>
        <Row>
          <Col><FaCarCrash style={{ height:'8em', width:'8em', margin:'4em' }} /></Col>
        </Row>
        <Row>
          <Col></Col>
        </Row>
      </Container>
      <Container className="mt-auto footer-default">
        <Row className="">
          <Col>
            <small>&copy;{new Date().getFullYear()} Beep. <a href="#">Terms & Conditions</a></small>
          </Col>
        </Row>
      </Container>      
    </Container>

  );

  

}


